export default "__VITE_ASSET__xV6a3fGe__"